import { render, staticRenderFns } from "./RolesExport.vue?vue&type=template&id=3923068c"
import script from "./RolesExport.vue?vue&type=script&lang=js"
export * from "./RolesExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports